import Typography from "@material-ui/core/Typography";
import styled from "styled-components";

const StyledTypography = styled(Typography)`
  font-weight: ${({ $bold }) => ($bold ? "bold" : "")};
`;

export default StyledTypography;
